module.exports = __webpack_public_path__ + "static/media/IconTemplates_-11.dcd09d8d.svg";